<template>
    <section class="e-book section">
        <div class="wrap">
            <h2 class="e-book__heading section__heading">
                {{ $t('sections.e_book.heading') }}
            </h2>
            <p class="e-book__text">
                {{ $t('sections.e_book.text') }}
            </p>
            <div class="e-book__buttons section__buttons ra">
                <button class="button button--primary" @click="downloadEbook">
                    {{ $t('sections.e_book.button') }}
                </button>
            </div>
        </div>
    </section>
</template>

<script>
import modalMixin from '~/mixins/modalMixin';

export default {
    name: 'EBook',
    mixins: [modalMixin],
    methods: {
        downloadEbook() {
            this.displayEBookModal();
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/_variables.scss';

.e-book {
    padding: 50px 0;

    @include md {
        padding: 100px 0;
    }

    &__heading {
        margin-bottom: 20px;
    }

    &__text {
        max-width: 580px;
        margin: auto;
        text-align: left;
    }
}
</style>
